import {bootstrapModule} from 'src/utilities/vuex'
import {camelize, kvps} from 'src/utilities/utils'
import {OK} from 'http-status-codes'
import {ptracGetEntities} from 'src/utilities/ptracApi'

const state = {
  address: [],
  company: [],
  task: [],
  project: []
}

const _typeStore = {
  namespaced: true,
  state,
  actions: {
    async fetchByEntityType({ commit }, entityType) {
      const response = await ptracGetEntities(`types/search/findByEntityTypeOrderBySortAsc?entityType=${entityType}`)
      if (OK === response.status) {
        commit(camelize(entityType), kvps(response.data, 'name', 'name'))
      }
      return response
    }
  }
}

export {_typeStore}
export default bootstrapModule(_typeStore)
